import axiosInstance from '@/store/axios';
import { rejectErrorApiV2 } from '@/store/helper';

const emptyFileJob = {
  input: {
    url: '',
  },
  profile: {
    audio_template: { name: '' },
    video_template: { name: '' },
  },
  outputs: [{}],
};

export default {
  namespaced: true,
  state: {
    fileJobs: [],
    selectedJob: emptyFileJob,
    liveJobs: [],
  },
  getters: {
    getFileJobs(state) {
      return state.fileJobs;
    },
    getLiveJobs(state) {
      return state.liveJobs;
    },
  },
  mutations: {
    setFileJobs(state, jobs) {
      state.fileJobs = jobs;
    },
    setLiveJobs(state, jobs) {
      state.liveJobs = jobs;
    },
  },
  actions: {
    getFileJobs({ commit }, args) {
      const params = {
        type: 'file',
        limit: args.limit,
        offset: args.offset,
        sort: args.sort || '-id',
      };
      return axiosInstance.get('/api/2/jobs', { params })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          commit('setFileJobs', result.data.jobs);
          return result.data.jobs;
        })
        .catch(error => Promise.reject(error));
    },
    getLiveJobs({ commit }, args) {
      const params = {
        type: 'live',
        limit: args.limit,
        offset: args.offset,
        sort: args.sort || '-id',
      };
      return axiosInstance.get('/api/2/jobs', { params })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          commit('setLiveJobs', result.data.jobs);
          return result.data.jobs;
        })
        .catch(error => Promise.reject(error));
    },
    getJobById({ commit }, id) {
      return axiosInstance.get(`/api/2/jobs/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.job;
        })
        .catch(error => Promise.reject(error));
    },
    getInputMetadata({ commit }, jobId) {
      return axiosInstance.get(`/api/2/jobs/${jobId}/input/metadata`)
        .then(result => result.data)
        .catch(error => console.log(error));
    },
    getFileJobLog({ commit }, jobId) {
      return axiosInstance.get(`/api/2/jobs/${jobId}/file-transcoder-log`)
        .then(result => result.data)
        .catch(error => console.log(error));
    },
    getOutputMetadata({ commit }, job) {
      function getOutputMetadata(jobId, outputId) {
        return axiosInstance.get(`/api/2/jobs/${jobId}/outputs/${outputId}/metadata`);
      }
      const requests = [];
      for (let i = 0; i < job.outputs.length; i++) {
        requests.push(getOutputMetadata(job.id, job.outputs[i].id));
      }
      return Promise.all(requests)
        .then(response => response)
        .catch(error => console.log(error));
    },
    // eslint-disable-next-line no-unused-vars
    getLiveJobMeta({ commit }, jobId) {
      return axiosInstance.get(`/api/2/jobs/${jobId}/live-instance`)
        .then(result => result.data)
        .catch(error => Promise.reject(error));
    },
    createJob({ commit }, job) {
      return axiosInstance({
        method: 'POST',
        url: '/api/2/jobs',
        data: job,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.job;
        })
        .catch(error => Promise.reject(error));
    },
    patchJob({ commit }, job) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/2/jobs/${job.id}`,
        data: job,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.job;
        })
        .catch(error => Promise.reject(error));
    },
    deleteJob({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/2/jobs/${id}`,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data;
        })
        .catch(error => Promise.reject(error));
    },
    deleteJobs({ commit }, ids) {
      function deleteJob(id) {
        return axiosInstance({ method: 'DELETE', url: `/api/2/jobs/${id}` });
      }
      return Promise.all(ids.map(deleteJob))
        .then((response) => {
          for (let i = 0; i < response.length; i++) {
            if (response[i].data.error) {
              return rejectErrorApiV2(response[i]);
            }
          }
          return response;
        })
        .catch(error => Promise.reject(error));
    },
    startJob({ commit }, id) {
      return axiosInstance({
        method: 'POST',
        url: `/api/2/jobs/${id}/commands/start`,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data;
        })
        .catch(error => Promise.reject(error));
    },
    stopJob({ commit }, id) {
      return axiosInstance({
        method: 'POST',
        url: `/api/2/jobs/${id}/commands/stop`,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data;
        })
        .catch(error => Promise.reject(error));
    },
    getLogs({ commit }, data) {
      const params = {
        job_id: data.jobId,
        limit: data.limit,
      };
      return axiosInstance.get('/api/1/event/list', { params })
        .then((result) => {
          if (result.data.hasOwnProperty('_events')) {
            return result.data._events;
          }
          return [];
        })
        .catch(error => Promise.reject(error));
    },
  },
};
